import { LoginOutputSubMenuData } from './login-output-sub-menu-data.model';


export class LoginOutputMenuData implements ILoginOutputMenuData {
    /** The auto-generated id of the tbl_application_menu */
    application_menu_id!: number;
    /** The main menu name with 100 character limit */
    menu_name!: string;
    /** The main menu icon with 100 character limit */
    mat_icon!: string;
    /** The sub menu icon with 2048 character limit */
    menu_url!: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type!: string;
    menu!: LoginOutputSubMenuData[];

    constructor(data?: ILoginOutputMenuData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_menu_id = _data["application_menu_id"];
            this.menu_name = _data["menu_name"];
            this.mat_icon = _data["mat_icon"];
            this.menu_url = _data["menu_url"];
            this.screen_type = _data["screen_type"];
            if (Array.isArray(_data["menu"])) {
                this.menu = [] as any;
                for (let item of _data["menu"])
                    this.menu!.push(LoginOutputSubMenuData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoginOutputMenuData {
        data = typeof data === 'object' ? data : {};
        let result = new LoginOutputMenuData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_menu_id"] = this.application_menu_id;
        data["menu_name"] = this.menu_name;
        data["mat_icon"] = this.mat_icon;
        data["menu_url"] = this.menu_url;
        data["screen_type"] = this.screen_type;
        if (Array.isArray(this.menu)) {
            data["menu"] = [];
            for (let item of this.menu)
                data["menu"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILoginOutputMenuData {
    /** The auto-generated id of the tbl_application_menu */
    application_menu_id: number;
    /** The main menu name with 100 character limit */
    menu_name: string;
    /** The main menu icon with 100 character limit */
    mat_icon: string;
    /** The sub menu icon with 2048 character limit */
    menu_url: string;
    /** The sub menu type must be "OVERVIEW" or "DETAIL" */
    screen_type: string;
    menu: LoginOutputSubMenuData[];
}

